import CloseIcon from '@mui/icons-material/Close';
import { Box, Card, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TextWrapper } from "../../../shared/components/formUtilities/useTextWrapper";
import { RegistrationNavBar } from "../components/registrationNavBar";
import { confirmEmail, getUser, loginUsingToken, Logout } from '../../../services/authService';
import { formatError } from '../../../services/axiosService';
import { ButtonWrapper } from '../../../shared/components/formUtilities/useButton';
import { buildLocalizeRoute } from '../../../helpers/languageHelper';
import { AppRoutes } from '../../../constants/appRoutes';
import { IS_SA } from '../../../config/appConfig';
import { OTPAuthenticationDialog } from '../../../shared/components/otpAuthenticationDialog';
import { OTPTypes } from '../../../constants/otpTypes';
import { Roles } from '../../../constants/roles';
import { Toaster } from '../../../shared/components/common/toaster';
import { useTranslation } from 'react-i18next';

export const ConfirmEmail = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showOTPAuth, setShowOTPAuth] = useState(false);
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const userId = query.get("userId") ? query.get("userId")?.replace(/ /g, "+") : null;
  const code = query.get("code") ? query.get("code")?.replace(/ /g, "+") : null;

  useEffect(() => {
    if (userId && code) {
      confirmEmailVerification();
    } else {
      setLoading(false);
      setError(t('userNotFoundEmail'));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const confirmEmailVerification = () => {
    confirmEmail({ userId, code }).then(resp => {
      let response = resp.data;
      loginUsingToken(response.token);
      Toaster({ msg: t('emailVerifiedSuccessfully'), isError: false });
      setTimeout(() => {
        onSuccess(response);
      }, 2000);
    }).catch(err => {
      setLoading(false);
      setError(formatError(err?.response?.data));
    });
  };

  const onSuccess = (tokenModel) => {
    if (tokenModel.otpRequested) {
      setShowOTPAuth(true);
    } else {
      setLoading(false);
      onNavigateNextStep();
    }
  };



  const onNavigateNextStep = () => {
    setLoading(false);
    let route = null;
    let navigationState = null;
    if (getUser()?.role === Roles.Investor) {
      const isKsaInternationalInvestor = IS_SA && localStorage.getItem("isKsaInternationalInvestor") === '1';
      const nextStep = (IS_SA && !isKsaInternationalInvestor) ? AppRoutes.IRegNafathVerification : AppRoutes.IRegPersonalInfo;
      route = `${AppRoutes.InvestorRegistration}/${nextStep}`;
      if (isKsaInternationalInvestor) {
        navigationState = { isKsaInternationalInvestor: true };
      }
    } else if (getUser()?.role === Roles.Borrower) {
      route = `${AppRoutes.BorrowerRegistartion}/${IS_SA ? AppRoutes.IRegNafathVerification : AppRoutes.BRegPersonalInfo}`;
    }
    if (route) {
      navigate(buildLocalizeRoute(route), { state: navigationState });
    } else {
      Logout();
      navigate(buildLocalizeRoute(AppRoutes.Login));
    }
  };

  return <Box className='w-full h-full'>
    <RegistrationNavBar marginBottom={0} isShowPlatform={false} isShowProfile={false}></RegistrationNavBar>
    {loading ? <Box className='h-[90%] w-full flex justify-center items-center'>
      <Box className='text-center'>
        <CircularProgress />
        <Box className='font-[500] mt-2'>{t('verifingYourEmail')}</Box>
      </Box>
    </Box> : <Box className='flex items-center justify-center md:p-0 p-4 w-full md:h-[85%] md:mt-0 mt-[32px]'>
      <Box component={Card} className="md:w-[520px] w-full flex flex-col justify-center !rounded-lg items-center p-8">
        <Box className='bg-red-500 p-4 flex items-center justify-center h-[60px] w-[60px] rounded-full shadow-sm'>
          <CloseIcon className="!text-[40px] !text-white" />
        </Box>
        <Box className='mt-3'>
          <TextWrapper classList="!font-semibold md:!text-[22px] text-[18px]" text={'Verification Failed'} />
        </Box>
        <Box className='text-sm caption !text-center mt-2 mb-4'>
          {error || t('pleaseReachOurTeamSomethingWrong')}
        </Box>
        <Box>
          <ButtonWrapper variant={'outlined'} onClick={() => {
            navigate(buildLocalizeRoute(`${AppRoutes.Login}`));
          }} label={t('backToLogin')} />
        </Box>
      </Box>
    </Box>}
    {showOTPAuth ? (
      <OTPAuthenticationDialog
        type={OTPTypes.Authentication}
        onClose={(isVerified) => {
          setShowOTPAuth(false);
          if (isVerified) {
            onNavigateNextStep();
          } else {
            setLoading(false);
            Logout();
            navigate(buildLocalizeRoute(AppRoutes.Login));
          }
        }}
        state={showOTPAuth}></OTPAuthenticationDialog>
    ) : null}
  </Box>;
};